import { render, staticRenderFns } from "./RequestItems.vue?vue&type=template&id=f3ebf8be&scoped=true&"
import script from "./RequestItems.vue?vue&type=script&lang=js&"
export * from "./RequestItems.vue?vue&type=script&lang=js&"
import style0 from "./RequestItems.vue?vue&type=style&index=0&id=f3ebf8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ebf8be",
  null
  
)

export default component.exports